import { createContext, useContext } from "react";

import { SearchSubmitIntent } from "./shouldUseQueryRedirect";

type SearchSubmitIntentContextValue = {
    setSubmitIntent: (intent: SearchSubmitIntent) => void;
};

export const SearchSubmitIntentContext =
    createContext<SearchSubmitIntentContextValue>({
        setSubmitIntent: () => undefined,
    });

export const useSearchSubmitIntent = () =>
    useContext(SearchSubmitIntentContext);

export default SearchSubmitIntentContext;
